import { SocureKycStatus } from '~/services/users/types';

export const KYC_TERMINAL_STATUSES = new Set<SocureKycStatus>([
  SocureKycStatus.ACCEPT,
  SocureKycStatus.REJECT,
  SocureKycStatus.REVIEW,
]);

// Statuses that keep the user on the current verification screen rather than
// routing away (shared "stay vs route" semantics, aligned with EDGE-28930).
export const NON_NAVIGATING_KYC_STATUSES = new Set<SocureKycStatus>([
  SocureKycStatus.REFER,
  SocureKycStatus.RESUBMIT,
  SocureKycStatus.MISSING,
]);

// localStorage key for the in-flight IDComply hosted-form session (token + timestamp).
export const IDCOMPLY_SESSION_KEY = 'idcomply_session';

// API versioning is header-based (NestJS VersioningType.HEADER). The DocV result
// endpoint has two handlers at the same path; V2 (GeoComply/IDComply resolve +
// persist) is only reached when this header is sent.
export const KYC_API_VERSION_HEADER = 'splash-accept-version';
export const KYC_API_VERSION_V2 = '2';

interface IPostKycVerifyPayload {
  firstName?: string;
  lastName?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
  mobileNumber?: string;
  email?: string;
  username?: string;
  customerUserId?: string;
  dateOfBirth?: {
    month: number;
    day: number;
    year: number;
  };
  sessionVersion?: number;
}

interface IGetKYCVerificationResponse {
  id: string;
  data: {
    status: SocureKycStatus;
    // Optional: the backend VerificationResponseDto marks referenceId optional,
    // and the V2 result response may omit it. Consumers must handle undefined.
    referenceId?: string;
    userId: string;
    docvTransactionToken?: string;
    docvOutcome?: SocureKycStatus | null;
  };
}

interface IPostDocumentRequestPayload {
  sessionVersion?: number;
}

interface IPostDocumentRequestResponse {
  id: string;
  data: {
    status: SocureKycStatus;
    userId: string;
    referenceId: string;
    docvTransactionToken: string;
    evalId: string;
    url?: string;
    idcomplyToken?: string;
    idcomplyOKey?: string;
    idcomplyBaseUrl?: string;
  };
}

interface IGetBlockedDomainResponse {
  id: string;
  data: {
    blocked: boolean;
  };
}

export {
  type IGetKYCVerificationResponse,
  type IPostDocumentRequestPayload,
  type IPostDocumentRequestResponse,
  type IGetBlockedDomainResponse,
  type IPostKycVerifyPayload,
};
